"use strict";

exports.__esModule = true;
exports["default"] = Education;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Education(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M481 151v225c0 24.8-14.5 30-30 30H316c-17.7 0-17.7 15 0 15h165c11.7 0 30-14.1 30-30V151c0-18-30-18-30 0zm-15 195V121c0-18-12.3-30-30-30H331c-40.2 0-60 18.1-60 45V390.9s7.8-14.9 24.4-14.9H436c17.7 0 30-12 30-30zM181 91H76c-17.7 0-30 12-30 30v225c0 18 9.1 30 26.9 30h140.6c16.6 0 27.6 15 27.6 15V136c-.1-26.9-19.9-45-60.1-45zm15 315H61c-15.5 0-30-5.2-30-30V151c0-18-30-18-30 0v240c0 15.9 18.3 30 30 30h165c17.7 0 17.7-15 0-15z"
  }));
}